/**
 * PPHU Imperium – Design Tokens
 * Design: Industrial Precision
 *
 * Zmień tu kolory, typografię i spacing globalnie.
 * Wszystkie wartości są używane w komponentach przez CSS variables lub bezpośrednio.
 */

export const colors = {
  // === BRAND COLORS ===
  yellow: '#F5C400',       // Żółty sygnałowy – kolor marki, CTA, akcenty
  yellowDark: '#D4A800',   // Ciemniejszy żółty – hover states
  yellowLight: '#FFF0A0',  // Jasny żółty – tła akcentowe

  navy: '#1A2744',         // Granat głęboki – tła sekcji, nagłówek, footer
  navyLight: '#243566',    // Jaśniejszy granat – karty, hover
  navyDark: '#111B30',     // Ciemniejszy granat – hero tło

  black: '#0D0D0D',        // Czerń techniczna – nagłówki, tekst
  white: '#F8F8F6',        // Biel robocza – tło jasnych sekcji
  offWhite: '#EFEFED',     // Szara biel – tło kart

  red: '#C41E1E',          // Czerwień akcentowa – alerty, ważne CTA

  // === SEMANTIC ===
  textDark: '#0D0D0D',
  textLight: '#F8F8F6',
  textMuted: '#6B7280',
  borderLight: '#E5E7EB',
  borderDark: 'rgba(255,255,255,0.12)',
} as const;

export const typography = {
  // Font families
  display: "'Manrope', sans-serif",   // H1, H2, H3, CTA labels
  body: "'Manrope', sans-serif",      // Treść, paragrafy

  // Font weights
  weightRegular: 400,
  weightMedium: 500,
  weightSemiBold: 600,
  weightBold: 700,
  weightExtraBold: 800,

  // Font sizes (rem)
  xs: '0.75rem',    // 12px – etykiety, meta
  sm: '0.875rem',   // 14px – drobny tekst
  base: '1rem',     // 16px – treść
  lg: '1.125rem',   // 18px – lead text
  xl: '1.25rem',    // 20px – H4
  '2xl': '1.5rem',  // 24px – H3
  '3xl': '1.875rem',// 30px – H2 mobile
  '4xl': '2.25rem', // 36px – H2 desktop
  '5xl': '3rem',    // 48px – H1 mobile
  '6xl': '3.75rem', // 60px – H1 desktop
  '7xl': '4.5rem',  // 72px – Hero H1

  // Line heights
  tight: 1.15,
  normal: 1.5,
  relaxed: 1.75,

  // Letter spacing
  tight_ls: '-0.02em',
  normal_ls: '0',
  wide_ls: '0.05em',
  wider_ls: '0.1em',
  widest_ls: '0.15em',
} as const;

export const spacing = {
  // Section padding
  sectionY: '5rem',       // 80px – pionowy padding sekcji
  sectionYLg: '7rem',     // 112px – większy padding
  sectionYSm: '3rem',     // 48px – mniejszy padding

  // Container
  containerMax: '1280px',
  containerPadX: '1rem',
  containerPadXMd: '1.5rem',
  containerPadXLg: '2rem',
} as const;

export const shadows = {
  card: '0 2px 12px rgba(0,0,0,0.08)',
  cardHover: '0 8px 32px rgba(0,0,0,0.14)',
  yellow: '0 6px 20px rgba(245, 196, 0, 0.35)',
  navy: '0 4px 24px rgba(26, 39, 68, 0.25)',
} as const;

export const transitions = {
  fast: '150ms cubic-bezier(0.23, 1, 0.32, 1)',
  normal: '250ms cubic-bezier(0.23, 1, 0.32, 1)',
  slow: '400ms cubic-bezier(0.23, 1, 0.32, 1)',
} as const;

// Company data – zmień tu dane firmy
export const companyData = {
  name: 'PPHU Imperium',
  fullName: 'PPHU Imperium Robert Gostomczyk',
  owner: 'Robert Gostomczyk',
  phone: '+48 535 270 537',
  phoneRaw: '+48535270537',
  phone2: '+48 535 270 537',
  phone2Raw: '+48535270537',
  phone2Owner: 'Mieszko Małachowski',
  email: 'pphuimperium@gmail.com',
  emailContact: 'rgostomczyk66@gmail.com',
  address: {
    street: 'ul. Kosynierów 21',
    city: 'Sławno',
    zip: '76-100',
    voivodeship: 'Zachodniopomorskie',
    full: 'ul. Kosynierów 21, 76-100 Sławno',
  },
  googleMapsUrl: 'https://www.google.com/maps?cid=2620159158954562091',
  googleBusinessUrl: 'https://www.google.com/maps?cid=2620159158954562091',
  yearsOnMarket: new Date().getFullYear() - 2009, // [DO UZUPEŁNIENIA] – rok założenia
  serviceArea: ['Sławno', 'Słupsk', 'Koszalin', 'Darłowo', 'Ustka', 'Mielno', 'Sianów', 'Polanów'],
  openingHours: {
    monday:    { open: '08:00', close: '15:45', closed: false },
    tuesday:   { open: '08:00', close: '15:45', closed: false },
    wednesday: { open: '08:00', close: '15:45', closed: false },
    thursday:  { open: '08:00', close: '15:45', closed: false },
    friday:    { open: '08:00', close: '15:45', closed: false },
    saturday:  { open: null,    close: null,    closed: true  },
    sunday:    { open: null,    close: null,    closed: true  },
  },
  openingHoursLabel: 'Pon–Pt: 08:00–15:45 | Sb–Nd: Zamknięte',
} as const;
